<template>
    <div class="">

        <section id="work-area" class="work-area pt-100 pb-70">
            <div class="container">
                <div class="row align-items-center">

                    <div class="col-lg-6">
                        <div class="work-content">

                            <div class="section-title">
                                <h2 v-if="!pgLoading">
                                    {{ ($i18n.locale == 'en') ? items.en.title : items.ar.title }}
                                </h2>
                                <h2 v-if="pgLoading" class="webkit-animation col-8 webkit-none-50"></h2>
                            </div>

                            <!-- <div v-if="pgLoading" class="col-12 webkit-animation webkit-none-60 mt-4"></div>
                            <div v-if="pgLoading" class="col-12 webkit-animation webkit-none-60 mt-4"></div>
                            <div v-if="pgLoading" class="col-12 webkit-animation webkit-none-60 mt-4"></div>
                            <div v-if="pgLoading" class="col-12 webkit-animation webkit-none-60 mt-4"></div>

                            <ul v-if="!pgLoading">
                                <li v-for="(item, idx) in items.childs" :key="idx">
                                    <h3><span>0{{ idx + 1 }}</span></h3>
                                    <p>{{ ($i18n.locale == 'en') ? item.en.title : item.ar.title }}</p>
                                </li>
                            </ul> -->

                            <p v-html="($i18n.locale == 'en') ? items.en.body : items.ar.body"></p>

                        </div>
                    </div>

                    <div class="col-lg-6 why-choose-us-images">
                        <div v-if="!pgLoading" class="work-img">
                            <!-- <img v-for="(item, idx) in items.childs" :key="idx"
                                :src="(item.image) ? item.image.url : ''"> -->

                            <img :src="items.image">
                        </div>
                        <div v-if="pgLoading" class="work-img webkit-animation webkit-none-260"></div>
                    </div>

                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: 'Why2PayMe',
    components: {
        //
    },
    data() {
        return {
            //
            items: null,
            pgLoading: true,
            refs: 'pages'
        }
    },
    mounted() { },
    created() {
        //
        this.fetchData();
    },
    methods: {
        //
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/' + this.refs,
                method: 'GET',
                data: {},
                headers: {
                    appId: process.env.VUE_APP_APPID
                },
            }
            this.axios(options)
                .then(res => {
                    this.pgLoading = false;
                    const result = res.data.data.rows.find((row) => { return row.title === 'Why choose 2pay me' });
                    this.items = result;
                })
                .catch(() => {
                    //
                })
                .finally(() => {
                    if (localStorage.getItem('locale') == 'ar') {
                        document.getElementById("work-area").classList.add('is-rtl');
                    }
                });
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
